<!-- StickyHeader: Render when at the top of the browser -->
<script lang="ts" setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue';

    const headerDiv = ref<HTMLElement>();
    const makeTitleSticky = ref<boolean>(false);

    onMounted(() => {
        addEventListener("scroll", onScroll);
    });
    onBeforeUnmount(() =>{
        removeEventListener("scroll", onScroll);
    });

    //function onScroll(evt: Event)
    function onScroll(evt: any)
    {
        checkIfTitleIsSticky();
    }

    function checkIfTitleIsSticky(doubleCheck: boolean = false)
    {
        if (!headerDiv.value)
            return;

        const clientRect = headerDiv.value.getBoundingClientRect();
        makeTitleSticky.value = clientRect.top <= 0;
    }    
</script>

<style scoped>
    .sticky {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;
    }
</style>

<template>
    <div ref="headerDiv"></div>
    <div v-if="makeTitleSticky" class="sticky">
        <slot name="sticky" />
    </div>
</template>